import React, { Component } from "react";

class AdminTopTierItems extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            showDeleteConfirmation: false
        }
    }

    componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	setWrapperRef = (node) => {
		this.wrapperRef = node;
	}

	handleClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				showDeleteConfirmation: false
			});
		}
	}

    deleteBtnClick = () => {
        this.setState({
            showDeleteConfirmation: true
        })
    }

    deleteConfirmBtnYes = (id) => {
        this.deleteCofirmBtnCancel();
        this.props.deleteTopTier(id);
    }

    deleteCofirmBtnCancel = () => {
        this.setState({
            showDeleteConfirmation: false
        })
    }

    render(){
        const { index, editId, topTier } = this.props;
        const { showDeleteConfirmation } = this.state;

        return (
            <div className={`tt-item ${editId !== null && editId === index ? 'editing' : ''}`}>
                <div className="tt-item-row">
                    <h3>{topTier.name}</h3>
                    <div className="tt-item-row-btns">
                        <button className={`icon-pencil ${editId !== null && editId === index ? 'editing' : ''}`} onClick={() => this.props.editTopTier(index)}></button>
                        <div style={{position: 'relative'}}>
                            <button className="icon-cross" onClick={() => this.deleteBtnClick()} disabled={showDeleteConfirmation}></button>
                            {showDeleteConfirmation && 
                            <div className="confirm-tooltip" ref={this.setWrapperRef}>
                                Delete "{topTier.name}"
                                <div className="confirm-tooltip-btns">
                                    <button onClick={() => this.deleteConfirmBtnYes(topTier.id)}>Yes</button>
                                    <button onClick={() => this.deleteCofirmBtnCancel()}>Cancel</button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminTopTierItems;


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/AdminTopTierItems.js